export var isLetter = function (char) {
    // valid when 'A' <= char <= 'z', char <= 'Z' || char >= 'a'
    return (char > 64 && char < 123 && (char < 91 || char > 96));
};
export var isNumber = function (char) {
    // valid when '0' <= char <= '9'
    return (char > 47 && char < 58);
};
//Forcefully formats strings and manually places cursor in correct position
export var autoformat = function (input, format, currValue, element) {
    var strippedString = ''; //Input string which has been stripped of formatting
    var formatIndex = 0;
    var copyPasteFormat = 0; //For when input that is copypasted is not formatted (counts the number of non-formatted characters in format string)
    var counter = 0; //counter for the advanceCursor.
    var advanceCursor = 0; //In the case that the last character is after several unformatted characters, counts the number of unformatted characters directly preceeding the last character
    var cursorStart = element.selectionStart; //Initial cursor position
    var preventWrongInputMovingForward = false; //When the input is less than the length of the format and the change in the input does not match the format, we want to prevent the cursor from moving forward
    if (input.length <= format.length) {
        for (var inputIndex = 0; inputIndex < input.length && inputIndex < format.length; inputIndex++) {
            while ((formatIndex < format.length) && (format[formatIndex] !== 'X') && (format[formatIndex] !== '9')) { //Neither a letter nor a number in the format string
                counter++;
                copyPasteFormat++;
                formatIndex++;
            }
            if ((isNumber(input.charCodeAt(inputIndex)) && format[formatIndex] === '9') || (isLetter(input.charCodeAt(inputIndex)) && format[formatIndex] === 'X')) { //If it matches the format string
                if (counter > 0) { //if there were any unformatted characters before this character
                    advanceCursor = counter; //Notes down how many unformatted characters before the current character
                    counter = 0; //Resets to 0 to ignore the unformatted characters that appear earlier in the string - only focus on those immediately preceeding the last character
                }
                strippedString += input[inputIndex];
                formatIndex++;
            } // else skips that index in input
        }
        var inputType = (isNumber(input.charCodeAt(cursorStart - 1)) ? 'number' : (isLetter(input.charCodeAt(cursorStart - 1)) ? 'letter' : 'something else'));
        if ((inputType !== 'number') && (format[cursorStart - 1] === '9')) {
            preventWrongInputMovingForward = true;
        }
        else if ((inputType !== 'letter') && (format[cursorStart - 1] === 'X')) {
            preventWrongInputMovingForward = true;
        }
        else if (inputType === 'something else') {
            preventWrongInputMovingForward = true;
        }
        var formattedString = '';
        var fmtIdx = 0; // formatIndex of this function
        if (Math.abs(currValue.length - input.length) <= 1) {
            copyPasteFormat = 0;
        }
        var caret_1 = cursorStart + copyPasteFormat;
        for (var valIndex = 0; valIndex < strippedString.length; valIndex++) {
            while ((fmtIdx < format.length) && (format[fmtIdx] !== 'X') && (format[fmtIdx] !== '9')) { // skips to next formatted char that is a letter or number
                formattedString += format[fmtIdx];
                fmtIdx++;
            }
            formattedString += strippedString[valIndex];
            fmtIdx++;
        }
        if (input.length < currValue.length) {
            window.requestAnimationFrame(function () {
                element.selectionStart = caret_1;
                element.selectionEnd = caret_1;
            });
        }
        else if ((format[caret_1 - 1] !== 'X') && (format[caret_1 - 1] !== '9')) {
            window.requestAnimationFrame(function () {
                element.selectionStart = caret_1 + advanceCursor;
                element.selectionEnd = caret_1 + advanceCursor;
            });
        }
        else {
            if (preventWrongInputMovingForward) {
                caret_1 -= 1;
            }
            window.requestAnimationFrame(function () {
                element.selectionStart = caret_1;
                element.selectionEnd = caret_1;
            });
        }
        // trailing formatted chars
        var trail = format.slice(fmtIdx);
        if (trail.indexOf('X') === -1 && trail.indexOf('9') === -1) {
            formattedString += trail;
        }
        // set the displayed value as the formatted string
        return formattedString;
    }
    window.requestAnimationFrame(function () {
        element.selectionStart = (cursorStart - 1);
        element.selectionEnd = (cursorStart - 1);
    });
    return currValue;
};
export var isFormatted = function (item, format) {
    if (format.length === 0) {
        return true;
    }
    if (item.length !== format.length) {
        return false;
    }
    for (var i = 0; i < item.length; i++) {
        var c = item.charCodeAt(i);
        if (format[i] === 'X') {
            if (!isLetter(c)) {
                return false;
            }
        }
        else if (format[i] === '9') {
            if (!isNumber(c)) {
                return false;
            }
        }
        else if (c !== format.charCodeAt(i)) {
            return false;
        }
    }
    return true;
};
var splitCamelCase = function (s) {
    return s.split(/([A-Z][a-z]+)/).filter(function (e) { return e; });
};
var createLabelString = function (array) {
    var firstStr = array[0];
    array[0] = firstStr.charAt(0).toUpperCase() + firstStr.slice(1);
    return array.join(' ');
};
export var makeLabel = function (s) {
    if (/^[a-z][A-Za-z0-9]*$/.test(s)) {
        var array = splitCamelCase(s);
        return createLabelString(array);
    }
    else if (/^[A-Z][A-Za-z0-9]*$/.test(s)) {
        var array = splitCamelCase(s);
        return array.join(' ');
    }
    else if (s.includes('_')) {
        var array = s.split('_');
        return createLabelString(array);
    }
    else if (s.includes('-')) {
        var array = s.split('-');
        return createLabelString(array);
    }
    else {
        return s;
    }
};
//# sourceMappingURL=index.js.map